"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FilterCell_1 = require("./FilterCell");
var kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
var kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
var settings = {
    inputComponent: function (props) { return React.createElement(kendo_react_inputs_1.Input, __assign({}, props)); },
    operatorComponent: function (props) { return React.createElement(kendo_react_dropdowns_1.DropDownList, __assign({}, props)); },
    emptyFilter: { operator: 'contains', value: '' }
};
/**
 * @hidden
 */
var TextFilterCell = /** @class */ (function (_super) {
    __extends(TextFilterCell, _super);
    function TextFilterCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TextFilterCell;
}(FilterCell_1.createFilterCell(settings)));
exports.TextFilterCell = TextFilterCell;
//# sourceMappingURL=TextFilter.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/filteringCells/TextFilter.js
// module id = 6494
// module chunks = 0